"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
require("reflect-metadata");
var DecoratorSymbol_1 = require("./DecoratorSymbol");
/**
 * Decorate a field with primitive format: String, Number, Boolean
 *
 * @param prototype {Function}
 * @constructor
 */
var Field = function (prototype) {
    return function (Target, property) {
        Object.defineProperty(Target, property, {
            enumerable: true,
            configurable: true,
            get: function () {
                return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
            },
            set: function (value) {
                Object.defineProperty(this, property, {
                    enumerable: true,
                    configurable: false,
                    get: function () {
                        return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
                    },
                    set: function (value) {
                        if (value === null || value === undefined) {
                            Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, value, this, property);
                            return;
                        }
                        Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, prototype(value), this, property);
                    }
                });
                this[property] = value;
            }
        });
    };
};
exports.Field = Field;
//# sourceMappingURL=Field.js.map